export enum ExploreTabNames {
  OneTime = 'oneTime',
  ShefService = 'shefService',
}
